import { render } from "./LottrackrPoweredIcon.vue?vue&type=template&id=401a6564&scoped=true&ts=true&lang=pug"
import script from "./LottrackrPoweredIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./LottrackrPoweredIcon.vue?vue&type=script&lang=ts&setup=true"

import "./LottrackrPoweredIcon.vue?vue&type=style&index=0&id=401a6564&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401a6564"]])

export default __exports__